import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import esCommon from './locales/es/common.json';
import esHome from './locales/es/home.json';
import esPricing from './locales/es/pricing.json';
import esModules from './locales/es/modules.json';
import esAI from './locales/es/ai.json';
import esAuthBridge from './locales/es/auth-bridge.json';
import esProof from './locales/es/proof.json';
import esComparison from './locales/es/comparison.json';
import esSegments from './locales/es/segments.json';
import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enPricing from './locales/en/pricing.json';
import enModules from './locales/en/modules.json';
import enAI from './locales/en/ai.json';
import enAuthBridge from './locales/en/auth-bridge.json';
import enProof from './locales/en/proof.json';
import enComparison from './locales/en/comparison.json';
import enSegments from './locales/en/segments.json';

i18n.use(initReactI18next).init({
  resources: {
    es: {
      common: esCommon,
      home: esHome,
      pricing: esPricing,
      modules: esModules,
      ai: esAI,
      'auth-bridge': esAuthBridge,
      proof: esProof,
      comparison: esComparison,
      segments: esSegments,
    },
    en: {
      common: enCommon,
      home: enHome,
      pricing: enPricing,
      modules: enModules,
      ai: enAI,
      'auth-bridge': enAuthBridge,
      proof: enProof,
      comparison: enComparison,
      segments: enSegments,
    },
  },
  lng: 'es',
  fallbackLng: 'es',
  ns: [
    'common',
    'home',
    'pricing',
    'modules',
    'ai',
    'auth-bridge',
    'proof',
    'comparison',
    'segments',
  ],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

// Screen readers pick pronunciation from <html lang>; keep it in step with the
// language the visitor chose instead of leaving the static "es" from index.html.
function syncDocumentLanguage(language: string): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.documentElement.lang = language.startsWith('en') ? 'en' : 'es';
}

i18n.on('languageChanged', syncDocumentLanguage);

export default i18n;
